import { getListaDeEtiquetas } from '../../../../../models/movimiento/dropdownEtiquetas/dropdownService'

export function actualizarDropdownEtiquetas (cereal, cerealVariedad) {
  return dispatch => {
    const promesaEtiqueta = getListaDeEtiquetas(cereal, cerealVariedad)
    const callback = (etiquetaDataPromise) => {
      dispatch({
        type: 'UPDATE_ETIQUETAS_DROPDOWN_PARA_FILTRO_PARA_EMBARQUE',
        etiquetas: etiquetaDataPromise['filas'] || []
      })
    }
    promesaEtiqueta.then(callback)
  }
}

export const submitFiltrosParaEmbarque = (values) => ({
  type: 'UPDATE_FILTROS_PARA_EMBARQUE',
  ...values
})

export function onFiltrosParaEmbarqueChange (changes, dispatch) {
  changes.cereal && dispatch({
    type: 'UPDATE_CEREAL_DROPDOWN_ETIQUETA_PARA_FILTRO_PARA_EMBARQUE',
    cereal: changes.cereal
  })
  changes.cerealVariedad && dispatch({
    type: 'UPDATE_CEREAL_VARIEDAD_DROPDOWN_ETIQUETA_PARA_FILTRO_PARA_EMBARQUE',
    cerealVariedad: changes.cerealVariedad
  })
}
